var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DefaultPageLayout',[_c('div',{staticClass:"query-string"},[(_vm.isDebug)?_c('QueryStringDebug'):[_c('QueryStringTopPanel'),_vm._l((_vm.endpoints),function(item){return _c('QueryStringDocs',{key:item.name,staticClass:"mt-9",attrs:{"item":item}})})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }